import { StatusBar } from "expo-status-bar";
import React, { useState, useEffect } from "react";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  View,
} from "react-native";

export default function Main() {
  const insets = useSafeAreaInsets();
  const [isEdit, setIsEdit] = useState(false);
  const [isCustomRoll, setIsCustomRoll] = useState(false);
  const [showHistory, setShowHistory] = useState(true);

  const [rolledValues, setRolledValues] = useState([]);
  const [historyValues, setHistoryValues] = useState([]);
  const [customValues, setCustomValues] = useState([]);

  const [diceCount, setDiceCount] = useState("1");
  const [minNumber, setMinNumber] = useState("1");
  const [maxNumber, setMaxNumber] = useState("6");
  const [count, setCount] = useState("10");

  useEffect(() => {
    let values = [];
    for (const i of Array(50).keys()) {
      values.push((1 + i).toString());
    }
    setCustomValues(values);
  }, []);

  const roll = () => {
    if (!isCustomRoll) {
      rollNumber();
    } else {
      rollCustom();
    }
  };

  const rollNumber = () => {
    if (historyValues.length >= 50) {
      setHistoryValues(historyValues.slice(0, 50));
    }
    setHistoryValues(rolledValues.concat(historyValues));

    let rolled = [];
    for (let i = 0; i < diceCount; i++) {
      rolled.push(
        Math.floor(
          Math.random() * (parseInt(maxNumber) - parseInt(minNumber) + 1) +
          parseInt(minNumber)
        )
      );
    }
    setRolledValues(rolled);
  };

  const rollCustom = () => {
    if (historyValues.length >= 50) {
      setHistoryValues(historyValues.slice(0, 50));
    }
    setHistoryValues(rolledValues.concat(historyValues));

    let rolled = [];
    for (let i = 0; i < diceCount; i++) {
      rolled.push(customValues[Math.floor(Math.random() * parseInt(count))]);
    }
    setRolledValues(rolled);
  };

  const updateCustomValue = (text, i) => {
    let values = [...customValues];
    values[i] = text;
    setCustomValues(values);
  };

  const updateDiceCountValue = (value) => {
    if (parseInt(value) < 1) {
      setDiceCount("1");
    } else if (parseInt(value) > 50) {
      setDiceCount("50");
    } else {
      setDiceCount(value);
    }
  };

  const updateCountValue = (value) => {
    if (parseInt(value) < 0) {
      setCount("0");
    } else if (parseInt(value) > 50) {
      setCount("50");
    } else {
      setCount(value);
    }
  };

  const updateMinNumber = (value) => {
    if (parseInt(value) > maxNumber) {
      setMinNumber(maxNumber);
    } else if (parseInt(value) < -1000000000) {
      setMaxNumber("-1000000000")
    } else {
      setMinNumber(value);
    }
  };

  const updateMaxNumber = (value) => {
    if (parseInt(value) < minNumber) {
      setMaxNumber(minNumber);
    } else if (parseInt(value) > 1000000000) {
      setMaxNumber("1000000000");
    } else {
      setMaxNumber(value);
    }
  };

  const flipEditMode = () => {
    setIsEdit(!isEdit)
    setHistoryValues([]);
    setRolledValues([]);
  }

  return (
    <View style={{
      paddingTop: insets.top,
      paddingLeft: insets.left,
      paddingBottom: insets.bottom,
      paddingRight: insets.right,
      flex: 1,
    }}>
      <StatusBar style="dark" />
      {!isEdit ? (
        <ScrollView style={{ paddingHorizontal: 20 }}>
          <TouchableOpacity
            style={styles.button}
            activeOpacity={0.7}
            onPress={flipEditMode}
          >
            <Text style={styles.buttonFont}>SETTINGS</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.rollButton}
            activeOpacity={0.7} onPress={roll}>
            <Text style={styles.buttonFont}>ROLL</Text>
          </TouchableOpacity>
          <TouchableOpacity activeOpacity={1} onPress={() => setShowHistory(!showHistory)}>
            {rolledValues.map((value, i) => (
              <Text key={i} style={styles.rolledFont}>
                {value}
              </Text>
            ))}
            {showHistory && <View>
              {historyValues.map((value, i) => (
                <Text key={i} style={styles.historyFont}>
                  {value}
                </Text>
              ))}
            </View>}
          </TouchableOpacity>
        </ScrollView>
      ) : (
        <ScrollView style={{ paddingHorizontal: 20 }}>
          <TouchableOpacity onPress={flipEditMode}
            activeOpacity={0.7} style={styles.button}>
            <Text style={styles.buttonFont}>BACK</Text>
          </TouchableOpacity>
          <Text style={styles.inputLabel}>Type</Text>
          <TouchableOpacity
            onPress={() => setIsCustomRoll(!isCustomRoll)}
            activeOpacity={0.7}
            style={styles.typeButton}
          >
            <Text style={styles.typeButtonFont}>
              {!isCustomRoll ? "NUMBER" : "CUSTOM"}
            </Text>
          </TouchableOpacity>
          {!isCustomRoll ? (
            <View>
              <Text style={styles.inputLabel}>Dices</Text>
              <TextInput
                style={styles.input}
                keyboardType="number-pad"
                onChangeText={(value) => updateDiceCountValue(value)}
                value={diceCount}
              />
              <Text style={styles.inputLabel}>Min</Text>
              <TextInput
                style={styles.input}
                keyboardType="number-pad"
                onChangeText={(value) => updateMinNumber(value)}
                value={minNumber}
              />
              <Text style={styles.inputLabel}>Max</Text>
              <TextInput
                style={styles.input}
                keyboardType="number-pad"
                onChangeText={(value) => updateMaxNumber(value)}
                value={maxNumber}
              />
            </View>
          ) : (
            <View>
              <Text style={styles.inputLabel}>Dices</Text>
              <TextInput
                style={styles.input}
                keyboardType="number-pad"
                onChangeText={(value) => updateDiceCountValue(value)}
                value={diceCount}
              />
              <Text style={styles.inputLabel}>Count</Text>
              <TextInput
                style={styles.input}
                keyboardType="number-pad"
                onChangeText={(value) => updateCountValue(value)}
                value={count}
              />
              <Text style={styles.inputLabel}>Values</Text>
              {customValues
                .filter((_value, i) => i < count)
                .map((value, i) => (
                  <TextInput
                    key={i}
                    style={styles.scrollInput}
                    onChangeText={(text) => {
                      updateCustomValue(text, i);
                    }}
                    value={value}
                  />
                ))}
              <View style={styles.spacer2}></View>
            </View>
          )}
        </ScrollView>
      )
      }
    </View>
  );
}

const styles = StyleSheet.create({
  rollButton: {
    marginBottom: 16,
    padding: 130,
    borderWidth: 3,
  },
  button: {
    marginBottom: 16,
    padding: 10,
    borderWidth: 3,
  },
  typeButton: {
    padding: 10,
    fontSize: 20,
    borderWidth: 3,
  },
  typeButtonFont: {
    fontSize: 20,
    fontWeight: "bold",
  },
  spacer2: {
    marginVertical: 160,
  },
  buttonFont: {
    fontSize: 30,
    textAlign: "center",
    fontWeight: "bold",
  },
  rolledFont: {
    textAlign: "center",
    fontSize: 26,
    fontWeight: "500",
  },
  historyFont: {
    textAlign: "center",
    fontSize: 20,
    color: "#aaa",
  },
  inputLabel: {
    fontSize: 20,
    marginTop: 24,
    marginBottom: 4,
    fontWeight: "bold",
  },
  input: {
    borderWidth: 3,
    padding: 10,
    flex: 1,
    fontSize: 20,
    textAlignVertical: "center",
  },
  scrollInput: {
    borderWidth: 3,
    padding: 10,
    marginBottom: 16,
    fontSize: 20,
    textAlignVertical: "center",
  },
});
